import { Link } from "react-router-dom";
import '../styles/EventsStyles/PrivacyModal.css';
import EventsLayout from "../components/EventsSection/EventsLayout";
import PrivacyNoticeContent from "../components/EventsSection/PrivacyNoticeContent";

// /events/privacy: the privacy notice for webinar registrations as its own page, linked from the
// webinars footer. The registration form shows the same notice in a pop-up.
const WebinarPrivacy = () => (
  <EventsLayout title="Privacy notice">
    <div className="km-container ev-privacy-page">
      <p className="ev-privacy-eyebrow">Webinars &amp; Workshops</p>
      <h1>Privacy notice</h1>
      <p className="km-lead">
        How Kole Medical collects, uses and protects the details you give when you register for a webinar.
      </p>
      <div className="km-card ev-privacy-card">
        <PrivacyNoticeContent />
      </div>
      <Link className="km-btn km-btn--outline" to="/events">Back to upcoming webinars</Link>
    </div>
  </EventsLayout>
);

export default WebinarPrivacy;
